export function baseHrefUrl(path: string): string {
  const base = document.baseURI.endsWith('/') ? document.baseURI : `${document.baseURI}/`;
  return new URL(path, base).toString();
}
